/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/error.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Error
 */
export interface Error {
    /**
     * @generated from protobuf field: optional string error_message = 1;
     */
    error_message?: string;
    /**
     * @generated from protobuf field: optional int32 status_code = 2;
     */
    status_code?: number;
    /**
     * @generated from protobuf field: optional string error_code = 3;
     */
    error_code?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Error$Type extends MessageType<Error> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Error", [
            { no: 1, name: "error_message", kind: "scalar", localName: "error_message", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Page not found", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Message to describe the error" } },
            { no: 2, name: "status_code", kind: "scalar", localName: "status_code", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "404", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "HTTP status code or custom error id" } },
            { no: 3, name: "error_code", kind: "scalar", localName: "error_code", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "page_not_found", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Unique error code" } }
        ]);
    }
    create(value?: PartialMessage<Error>): Error {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Error>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Error): Error {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string error_message */ 1:
                    message.error_message = reader.string();
                    break;
                case /* optional int32 status_code */ 2:
                    message.status_code = reader.int32();
                    break;
                case /* optional string error_code */ 3:
                    message.error_code = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Error, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string error_message = 1; */
        if (message.error_message !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.error_message);
        /* optional int32 status_code = 2; */
        if (message.status_code !== undefined)
            writer.tag(2, WireType.Varint).int32(message.status_code);
        /* optional string error_code = 3; */
        if (message.error_code !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.error_code);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Error
 */
export const Error = new Error$Type();
